import { render, staticRenderFns } from "./ContasSinteticas.vue?vue&type=template&id=13a182b0&"
import script from "./ContasSinteticas.vue?vue&type=script&lang=js&"
export * from "./ContasSinteticas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports